import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=1a80b9ce"
import script from "./input-file.vue?vue&type=script&lang=js"
export * from "./input-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports